import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import sharing from './modules/sharing';
import storageData from './modules/persist';
import DriverSettlementTwo from "./modules/DriverSettlementTwo"; //批量支付module

const dataState = createPersistedState({
    paths: ['listAdd', 'listDel', 'dirverHead', 'listAdd2', 'listDel2', 'dirverHead2'],
})

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        sharing,
        storageData,
        DriverSettlementTwo
    },
    plugins: [dataState]
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js